import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

const Vista_DetailsPage = React.lazy(
  () => import('@/features/equipamentos/Vista/Vista-DetailsPage'),
)
const Vista_HeaderOutlet = React.lazy(
  () => import('@/features/equipamentos/Vista/Vista-HeaderOutlet'),
)

export default function Component() {
  return (
    <Routes>
      <Route index element={<Navigate to="/app/entity/equipamentos" />} />
      <Route path=":vistaId" element={<Vista_HeaderOutlet />}>
        <Route path="detalhes" element={<Vista_DetailsPage />} />
      </Route>
    </Routes>
  )
}
